import { render } from "./masters.vue?vue&type=template&id=963e10c6"
import script from "./masters.vue?vue&type=script&lang=js"
export * from "./masters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__